<template>
  <div class="header-nav-wrapper hide-for-medium">
    <header class="header-nav">
      <div class="header-nav__left">
        <button
          v-if="customTrigger"
          type="button"
          @click="$emit('customTriggerAction')"
        >
          <LeftArrowIcon />
        </button>
        <button
          v-else
          type="button"
          @click="openHamburger"
        >
          <HamburgerSvg />
        </button>
      </div>

      <slot name="action" />
      <div class="header-nav__center">
        {{ label }}
      </div>

      <div class="header-nav__right">
        <slot />
      </div>
    </header>
  </div>
</template>

<script setup>
import { inject } from 'vue';
import HamburgerSvg from '@/images/hamburger.svg';
import LeftArrowIcon from '@/images/arrow-left.svg';

defineProps({
  customTrigger: { type: Boolean, required: false, default: false },
  label: { type: String, required: false, default: null },
});

defineEmits(['customTriggerAction']);

/**
 * @constant
 * @type {EventTarget}
 */
const eventTarget = inject('eventTarget');

function openHamburger() {
  eventTarget.dispatchEvent(new CustomEvent('hamburgerOpen'));
}
</script>
